import { initialErrors } from '../Constants/TryOn.constants';
import { Types } from '../Constants/Types';

import TryOn from '../Interfaces/tryOn.interface';

const TryOnReducer = (
  state: TryOn['status'] = {
    productTypes: [],
    userStyles: [],
    globalSettings: {
      _id: '',
      imageResolution: '',
      isActive: false,
      totalMonthlyRequests: 0,
      userRequestsPerDay: 0,
      userRequestsPerMonth: 0,
      userRequestsPerWeek: 0,
    },
    lGSettings: false,
    lstyles: false,
    lproducts: false,
    error: initialErrors,
  },
  action: TryOn['action']
) => {
  switch (action.type) {
    case Types.FETCH_PRODUCT_TYPES:
      return {
        ...state,
        productTypes: action.payload,
      };

    case Types.UPDATE_PRODUCT_TYPES:
      return {
        ...state,
        productTypes: state.productTypes.map((productType) =>
          productType._id === action.payload._id
            ? { ...productType, title: action.payload.title }
            : productType
        ),
      };

    case Types.CREATE_PRODUCT_TYPE:
      return {
        ...state,
        productTypes: [action.payload, ...state.productTypes],
      };

    case Types.DELETE_PRODUCT_TYPES:
      return {
        ...state,
        productTypes: state.productTypes.filter(
          (productType) => productType._id !== action.payload
        ),
      };

    case Types.START_PRODUCT_TYPES:
      return { ...state, lproducts: true };

    case Types.END_PRODUCT_TYPES:
      return { ...state, lproducts: false };

    case Types.RESET_PRODUCT_TYPES:
      return { ...state, error: initialErrors };

    case Types.ERROR_PRODUCT_TYPES:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };
    case Types.FETCH_USER_STYLES:
      return {
        ...state,
        userStyles: action.payload,
      };

    case Types.UPDATE_USER_STYLES:
      return {
        ...state,
        userStyles: state.userStyles.map((userStyle) =>
          userStyle._id === action.payload._id
            ? { ...action.payload }
            : userStyle
        ),
      };

    case Types.CREATE_USER_STYLE:
      return {
        ...state,
        userStyles: [action.payload, ...state.userStyles],
      };

    case Types.DELETE_USER_STYLES:
      return {
        ...state,
        userStyles: state.userStyles.filter(
          (userStyle) => userStyle._id !== action.payload
        ),
      };

    case Types.START_USER_STYLES:
      return { ...state, lstyles: true };

    case Types.END_USER_STYLES:
      return { ...state, lstyles: false };

    case Types.RESET_USER_STYLES:
      return { ...state, error: initialErrors };

    case Types.ERROR_USER_STYLES:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    case Types.FETCH_GLOBAL_AI_SETTINGS:
      return {
        ...state,
        globalSettings: action.payload,
      };

    case Types.UPDATE_GLOBAL_AI_SETTINGS:
      return {
        ...state,
        globalSettings: action.payload,
      };

    case Types.START_GLOBAL_AI_SETTINGS:
      return { ...state, lGSettings: true };
    case Types.END_GLOBAL_AI_SETTINGS:
      return { ...state, lGSettings: false };

    case Types.RESET_GLOBAL_AI_SETTINGS:
      return { ...state, error: initialErrors };

    default:
      return state;
  }
};

export default TryOnReducer;
